import type { OsasFollowUpConsultCustomControlData } from '@common/validation/customControls/osas/osasFollowUpConsultSchema';
import { CustomControlCode } from '@common/enums/serviceWorkflow/customControlCode';
import { CustomControlRegistry } from '../../customControlRegistry';
import { initialData } from './osasFollowUpConsultData';
import { OsasFollowUpConsultEdit } from './OsasFollowUpConsultEdit';
import { OsasFollowUpConsultRead } from './OsasFollowUpConsultRead';

CustomControlRegistry.instance.register<OsasFollowUpConsultCustomControlData>({
    EditElement: OsasFollowUpConsultEdit,
    ReadElement: OsasFollowUpConsultRead,
    code: CustomControlCode.OSASFollowUpConsult,
    initialData,
    version: 1,
});
